var render = function () {
  var _vm$data$price, _vm$data$price2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "compare-product-card"
  }, [_c('div', {
    staticClass: "compare-product-card__wrapper"
  }, [_c('nuxt-link', {
    staticClass: "compare-product-card__image",
    attrs: {
      "to": _vm.data.path || '#'
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.emit('product-select');
      }
    }
  }, [_c('LazyImg', {
    attrs: {
      "img": _vm.data.thumbnail.x1 || _vm.data.image,
      "srcset": _vm.data.thumbnail.x2,
      "alt": _vm.data.name
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "compare-product-card__content"
  }, [_c('div', {
    staticClass: "compare-product-card__info-wrapper"
  }, [(_vm$data$price = _vm.data.price) !== null && _vm$data$price !== void 0 && _vm$data$price.common ? _c('TSPrice', {
    staticClass: "compare-product-card__price",
    attrs: {
      "price": _vm.data.price
    }
  }) : _vm._e(), _vm._v(" "), _c('nuxt-link', {
    staticClass: "link link_wu compare-product-card__title-desktop",
    attrs: {
      "to": _vm.data.path || '#'
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.emit('product-select');
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.data.name) + "\n        ")])], 1)])], 1), _vm._v(" "), _c('ActionCart', {
    staticClass: "compare-product-card__cart",
    attrs: {
      "id": _vm.data.id,
      "product": _vm.data,
      "price": (_vm$data$price2 = _vm.data.price) === null || _vm$data$price2 === void 0 ? void 0 : _vm$data$price2.common.value,
      "modal": {
        image: _vm.data.thumbnail.x1,
        link: _vm.data.path,
        name: _vm.data.name,
        price: _vm.data.price,
        category: _vm.data.category,
        offer: _vm.data.offer,
        id: _vm.data.id
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var _vm$data$status;

        var add = _ref.add,
            increaseAmount = _ref.increaseAmount,
            decreaseAmount = _ref.decreaseAmount,
            quantity = _ref.quantity,
            active = _ref.active,
            loading = _ref.loading;
        return [((_vm$data$status = _vm.data.status) === null || _vm$data$status === void 0 ? void 0 : _vm$data$status.code) === 'NOT_AVAILABLE' ? _c('div', {
          staticClass: "product-card__button-disabled"
        }, [_vm._v("\n      Распродано\n    ")]) : _c('div', {
          attrs: {
            "data-e2e": "add-to-basket"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              active ? null : (add({
                quantity: 1,
                product: _vm.product
              }), _vm.emit('add-product'));
            }
          }
        }, [active ? _c('TSCounter', {
          attrs: {
            "quantity": quantity,
            "max": 999,
            "loading": loading
          },
          on: {
            "decrease": function ($event) {
              return decreaseAmount({
                quantity: $event
              });
            },
            "increase": function ($event) {
              return increaseAmount({
                quantity: $event
              });
            }
          }
        }) : _c('CartTool', {
          attrs: {
            "loading": loading
          }
        }, [_vm._v("\n        В корзину\n      ")])], 1)];
      }
    }])
  }), _vm._v(" "), _c('nuxt-link', {
    staticClass: "link link_wu compare-product-card__title-mobile",
    attrs: {
      "to": _vm.data.path || '#'
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.emit('product-select');
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.data.name) + "\n  ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }